import { Component, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { UserAppService } from 'src/app/services/user-app.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-otp-verification',
  template: `
    <div class="otp-dialog-body">
      <div mat-dialog-title class="otp-header">
        <h2 class="dialog-title">Email verification</h2>
        <p class="dialog-sub">Enter the 6-digit code we sent to your email address.</p>
      </div>

      <div mat-dialog-content class="otp-content">
        <div class="field">
          <mat-form-field class="otp-field">
            <mat-label>Enter your OTP</mat-label>
            <input matInput [(ngModel)]="otp" inputmode="numeric" maxlength="6" />
          </mat-form-field>
        </div>

        <div class="resend">
          <span>Didn't get a code?</span>
          <span *ngIf="isResendDisabled" class="disabled">Resend in ({{ remainingTime }})</span>
          <span *ngIf="!isResendDisabled" class="link" (click)="resendOtp()">Resend</span>
        </div>
      </div>

      <div mat-dialog-actions class="otp-actions">
        <button type="button" class="btn-ghost" [mat-dialog-close]="false">Close</button>
        <button
          type="button"
          class="btn-primary"
          (click)="verifyEmail()"
          [disabled]="otp.length != 6"
        >
          Verify
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./otp-verification.component.scss'],
})
export class OtpVerificationComponent implements OnInit {
  otp: string = '';
  currentTime: Date = new Date();
  countdownSubscription: Subscription = new Subscription();;
  isResendDisabled: boolean = true;
  remainingTime: number = 90;

  constructor(
    private userService: UserAppService,
    private snackBar: SharedFeaturesService,
    private dialogRef: MatDialogRef<OtpVerificationComponent>
  ) {}

  ngOnInit(): void {
    this.startCountdown();
  }

  startCountdown() {
    const countdown$ = interval(1000);

    this.countdownSubscription = countdown$.subscribe(() => {
      if (this.remainingTime > 0) {
        this.remainingTime--;
      } else {
        this.isResendDisabled = false;
        this.countdownSubscription.unsubscribe();
      }
    });
  }

  delay() {
    return this.remainingTime;
  }

  resendOtp() {
    this.userService.generateNewOtp().subscribe({
      next: (response: any) => {
        this.snackBar.openSnackBar(
          response.message,
          'Close',
          'success-snackbar'
        );
      },
      error: (error: any) => {
        this.snackBar.openSnackBar(
          error.error.message || error.message,
          'Close',
          'error-snackbar'
        );
      },
    });
  }

  verifyEmail() {
    let data = { verify_otp: this.otp };
    this.userService.verifyEmail(data).subscribe({
      next: (response: any) => {
        this.snackBar.openSnackBar(
          response.message,
          'Close',
          'success-snackbar'
        );
        this.dialogRef.close(true);
      },
      error: (error: any) => {
        this.snackBar.openSnackBar(
          error.error.error || error.message,
          'Close',
          'error-snackbar'
        );
      },
    });
  }
}
